import React, { Component } from 'react';
import $ from 'jquery';
import { Row, Col, Input, Button } from 'react-materialize';
import _ from 'lodash';

export default class GroupSelect extends Component {

    constructor(props){
        super(props);
        this.changeLimit = (val) => { this.props.onChange(val)}
        this.state = { limit: this.props.value.limit }
        this.debouncedLimit = _.debounce(this.changeLimit.bind(this), 300, {})
    }

    onChangeAttribute(event){
        if(this.props.value.name != event.target.value){
            var attr = this.props.attributeList.find(a => a.name == event.target.value);
            var val = {name:attr.name};
            if(attr.type=='TIME'){
                val.func = 'MONTH';
                val.limit = 30;
                val.sort = {
                    dir: 'asc',
                    name: attr.name
                }
            } else {
                val.func = null;
            }
            if(this.props.value.name === this.props.value.sort.name){
                val.sort = {
                    name: val.name,
                    dir: 'asc'
                };
            }
            val = Object.assign(this.props.value,val);
            this.props.onChange(val);
        }
    }
    onChangeLimit(event){
        let nlimit = event.target.value;

        if(this.props.value.limit != nlimit && nlimit > 0){
            var val = Object.assign(this.props.value,{limit:parseInt(event.target.value)});
            this.setState({ limit: event.target.value })
            this.debouncedLimit(val);
        }
    }
    onChangeFunc(event){
        if(this.props.value.func != event.target.value){
            var val = Object.assign(this.props.value,{func:event.target.value})
            this.props.onChange(val);
        }
    }
    onChangeSortDir(event){
        if(this.props.value.sort.dir != event.target.value){
            var sort = Object.assign(this.props.value.sort,{dir:event.target.value});
            var val = Object.assign(this.props.value,{sort:sort});
            this.props.onChange(val);
        }
    }
    onChangeSortName(event){
        if(this.props.value.sort.name != event.target.value){
            var metric = this.props.metricList.find(m => m.name == event.target.value);
            var sort = {name:event.target.value};
            if(metric){
                sort.metricFunc = 'sum';
            } else {
                sort.metricFunc = null;
            }
            sort = Object.assign(this.props.value.sort,sort);
            var val = Object.assign(this.props.value,{sort:sort});
            this.props.onChange(val);
        }
    }
    onChangeSortMetricFunc(event){
        if(this.props.value.sort.metricFunc != event.target.value){
            var sort = Object.assign(this.props.value.sort,{metricFunc:event.target.value});
            var val = Object.assign(this.props.value,{sort:sort});
            this.props.onChange(val);
        }
    }

    componentDidUpdate(){
        setTimeout(() => {
            $('.dropdown-content.select-dropdown').css({'min-width':200})
        }, 200)
    }

    render(){
        var attr = this.props.value.name.replace(".keyword", "")

        attr = attr.charAt(0).toUpperCase() + attr.substr(1)
        return <div className="group-select">
            <Row>
                <h6><b>{this.props.title}</b></h6>
                <Input
                    label="Attribute"
                    l={7} m={7} s={7}
                    type="select"
                    value={this.props.value.name}
                    onChange={this.onChangeAttribute.bind(this)}>
                    {this.props.attributeList.map((attr,idx) => {
                        return <option key={idx} value={attr.name}>{attr.label}</option>
                    })}
                </Input>
                <div className="col input-field s5 m5 l5">
                <label htmlFor="limit" className="active">Limit</label>
                <input
                    id="limit"
                    step="1"
                    min="1"
                    type="number"
                    value={this.state.limit}
                    onChange={this.onChangeLimit.bind(this)}/>
                </div>
            </Row>
            {this.props.value.func &&
                <Row>
                    <Input
                        label="Granularity"
                        l={5} m={5} s={5}
                        type="select"
                        value={this.props.value.func}
                        onChange={this.onChangeFunc.bind(this)}>
                        <option value="SECOND">Second</option>
                        <option value="MINUTE">Minute</option>
                        <option value="HOUR">Hour</option>
                        <option value="DAY">Day</option>
                        <option value="MONTH">Month</option>
                        <option value="YEAR">Year</option>
                    </Input>
                </Row>
            }
            <Row>
                <Input
                    label="Sort By"
                    l={7} m={7} s={7}
                    type="select"
                    value={this.props.value.sort.name}
                    onChange={this.onChangeSortName.bind(this)}>
                    <option value="count">#Transactions</option>
                    <option value={this.props.value.name}>{attr}</option>
                    {this.props.metricList.map((metric,idx) => {
                        return <option key={idx} value={metric.name}>{metric.label}</option>
                    })}
                </Input>
                {this.props.value.sort.metricFunc &&
                    <Input
                        label="Sort Operation"
                        l={5} m={5} s={5}
                        type="select"
                        value={this.props.value.sort.metricFunc}
                        onChange={this.onChangeSortMetricFunc.bind(this)}>
                        <option value="sum">Sum</option>
                        <option value="avg">Average</option>
                        <option value="min">Min</option>
                        <option value="max">Max</option>
                    </Input>
                }
                <Input
                    label="Sort Direction"
                    l={12} m={12} s={12}
                    type="select"
                    value={this.props.value.sort.dir}
                    onChange={this.onChangeSortDir.bind(this)}>
                    <option value="asc">Ascending</option>
                    <option value="desc">Descending</option>
                </Input>
            </Row>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/GroupSelect.jsx